import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CM',
  quote: 'Armé mis primeros muebles y ya tengo tres encargos',
  name: 'Cristian M.',
  location: 'Córdoba'
}, {
  initials: 'MM',
  quote: 'Es como tener un profe al lado',
  name: 'Marcelo M.',
  location: 'Buenos Aires'
}, {
  initials: 'LP',
  quote: 'Pude animarme y seguir el camino de mi viejo',
  name: 'Laura P.',
  location: 'Mendoza'
}];
export function ShortTestimonials() {
  return <section className="py-16 px-4 bg-brand-gray" data-id="element-283">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-284">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center" data-id="element-285">
            <div className="w-16 h-16 bg-brand-steel text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-286">
              {t.initials}
            </div>
            <div className="flex text-brand-forge mb-4" data-id="element-287">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-288" />)}
            </div>
            <p className="text-lg font-bold text-gray-800 mb-4 italic" data-id="element-289">
              "{t.quote}"
            </p>
            <p className="text-sm text-gray-500 font-medium" data-id="element-290">
              — {t.name}, {t.location}
            </p>
          </div>)}
      </div>
    </section>;
}